$(function () {
    $('.marketing-switch .form-check-input').on('click', function () {
        const $wrap = $(this).closest('.marketing-switch');

        if ($wrap.hasClass('marketing-switch--all')) {
            const selectedValue = $wrap.find('.form-check-input:checked').val();
            $('.marketing-switch:not(.marketing-switch--all) .form-check-input[value="' + selectedValue + '"]')
                .trigger('click');
        }

        if (parseInt(this.value, 10) === 1) {
            $wrap.removeClass('set--off').addClass('set--on');
        } else {
            $wrap.removeClass('set--on').addClass('set--off');
        }

        validateAllConsents();
    });
});

function validateAllConsents()
{
    const $master = $('.marketing-switch--all').removeClass('set--on set--off');

    let allOn  = true;
    let allOff = true;
    let mixed  = false;

    let classicSwitch = $('.marketing-switch:not(.marketing-switch--all)');

    classicSwitch.each(function () {
        const $checked = $(this).find('.form-check-input:checked');
        const val = $checked.length ? $checked.val() : undefined;

        if (val === '1') {
            allOff = false;
        } else if (val === '0') {
            allOn = false;
        } else {
            mixed = true;
            return false;
        }

        if (!allOn && !allOff) {
            mixed = true;
            return false;
        }
    });

    if (!mixed) {
        if (allOn) {
            $master.addClass('set--on');
        } else if (allOff) {
            $master.addClass('set--off');
        }
    }

    let allSelected = true;
    classicSwitch.each(function () {
        if ($(this).find('.form-check-input:checked').length === 0) {
            allSelected = false;
            $('.marketing-switch--all').removeClass('set--off set--on');
            return false;
        }
    });

    let submit = $('.marketing-contents__cta');
    if (allSelected) {
        // submit.find('button').removeClass('is-inactive');
        submit.find('button').addClass('button--fill-red');
    } else {
        submit.find('button').removeClass('button--fill-red');
        // submit.find('button').addClass('is-inactive');
    }
}

function addMarketingConsentClass()
{
    let classicSwitch = $('.marketing-switch:not(.marketing-switch--all)');
    classicSwitch.each(function () {
        const $checked = $(this).find('.form-check-input:checked');
        const val = $checked.length ? $checked.val() : undefined;

        if (val === '1') {
            $(this).removeClass('set--off').addClass('set--on');
        }
        if (val === '0') {
            $(this).removeClass('set--off').addClass('set--off');
        }
    });
}

addMarketingConsentClass();